import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-card-brand-icon',
  templateUrl: './card-brand-icon.component.html',
  styles: [
    `
      :host {
        display: inline-block;
      }
    `,
  ],
})
export class CardBrandIconComponent {
  @Input() brand: string
}
